var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11101_14608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9.70833V7.68409C19 6.92326 18.7109 6.19084 18.1913 5.63511L16.4286 3.75L14.7464 1.95102C14.1791 1.34434 13.3857 1 12.5551 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H16.2857",
    stroke: "#878EA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7H11",
    stroke: "#878EA6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12H14",
    stroke: "#878EA6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17H9",
    stroke: "#878EA6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1V1.42857V5C14 6.10457 14.8954 7 16 7H18.6429H19",
    stroke: "#878EA6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5226 11.0192L19 11L18.4774 11.0192L17.9604 11.0765L17.4549 11.1713L16.9663 11.3026L16.5 11.4689L16.0611 11.6684L15.6543 11.899L15.2843 12.158L14.9549 12.4428L14.6699 12.75L14.4323 13.0764L14.2447 13.4184L14.1093 13.7723L14.0274 14.1342L14 14.5L14.0274 14.8658L14.1093 15.2277L14.2447 15.5816L14.4323 15.9236L14.6699 16.25L14.9549 16.5572L15.2843 16.842L15.6543 17.101L16.0611 17.3316L16.5 17.5311L16.9663 17.6974L17.4549 17.8287L17.9604 17.9235L18 17.9279V21H20V17.9279L20.0396 17.9235L20.5451 17.8287L21.0337 17.6974L21.5 17.5311L21.9389 17.3316L22.3457 17.101L22.7157 16.842L23.0451 16.5572L23.3301 16.25L23.5677 15.9236L23.7553 15.5816L23.8907 15.2277L23.9726 14.8658L24 14.5L23.9726 14.1342L23.8907 13.7723L23.7553 13.4184L23.5677 13.0764L23.3301 12.75L23.0451 12.4428L22.7157 12.158L22.3457 11.899L21.9389 11.6684L21.5 11.4689L21.0337 11.3026L20.5451 11.1713L20.0396 11.0765L19.5226 11.0192Z",
    fill: "#878EA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11101_14608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitMenu);
export default __webpack_public_path__ + "static/media/SubmitMenu.2d456a8bd36222b134012d7a12a55094.svg";
export { ForwardRef as ReactComponent };